"use client";

import styled from "styled-components";

import { PINNED_CLASS_NAME } from "@/shared/hooks/use-sticky-condition";

export const Wrapper = styled.header`
  width: 100%;
  z-index: 100;
  position: sticky;
  background-color: var(--background-primary);
  top: -1px;
  left: 0;
  height: 48px;
  &.${PINNED_CLASS_NAME} {
    background-color: var(--background-secondary);
  }
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
`;

export const Content = styled.div`
  margin: 0 auto;
  padding: 8px 24px;
  justify-content: space-between;
  display: flex;
  height: 100%;
  align-items: center;
`;

export const Logo = styled.div`
  width: 127px;
  height: 24px;
  background-image: var(--logo);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`;
